import { render, staticRenderFns } from "./DataTableSimple.vue?vue&type=template&id=eaebb824&"
import script from "./DataTableSimple.vue?vue&type=script&lang=js&"
export * from "./DataTableSimple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports